<template>
    <div class="UnEnrollParticipantTab">
      <div class="container-fluid">
          <div class="row margin-Top-2Perc margin-bottom-2Perc margin-left-0Point3Perc grey-border">
              <div class="left-border col-md-12 col-lg-12 font-size-18px padding-top-bottom-point-7Perc cursor-pointer" v-bind:class="{'background-gray': isActive === 1}" v-on:click="renderEnrollParticipantUI($event,1)">
                Multiple Participants using CSV template
              </div>    
          </div>      
      </div>
      <!-- Start of Create Multiple Participants UI-->  
      <enroll-multiple-participants v-if="isActive === 1" :comingFromUnEnrollment="true"></enroll-multiple-participants>  
      <!-- End of Create Multiple Participants UI-->                
    </div>    
</template>

<script>
import EnrollSingleParticipant from '@/components/EnrollSingleParticipant'
import EnrollMultipleParticipants from '@/components/EnrollMultipleParticipants'
export default {
  data: function () {
    return {
      isActive: 1
    }
  },
  components: {
    'enroll-single-participant': EnrollSingleParticipant,
    'enroll-multiple-participants': EnrollMultipleParticipants
  },
  methods: {
    renderEnrollParticipantUI: function (event, flagToUpdate) {
      this.isActive = flagToUpdate
      this.$emit('clickedTab', flagToUpdate)
    }
  },
  name: 'UnEnrollParticipantTab'
}
</script>

<style scoped>
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.background-color-red {
  background-color: red;
}
.border-black {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}

.font-size-18px {
  font-size: 18px;
}
.background-gray {
  background-color: #ddd;
}
.padding-top-bottom-point-7Perc {
  padding-top: 0.7% !important;
  padding-bottom: 0.7% !important;
}
.margin-left-1Perc{
  margin-left:1%;
}
.margin-left-0Point3Perc{
  margin-left:0.3%;
}
</style>





// WEBPACK FOOTER //
// src/components/UnEnrollParticipantTab.vue